// extracted by mini-css-extract-plugin
export var askAiIcon = "_oj-k";
export var category = "_oj-a";
export var categoryHeader = "_oj-f";
export var container = "_oj-0";
export var group = "_oj-b";
export var groupItems = "_oj-g";
export var groupSeparator = "_oj-l";
export var highlight = "_oj-8";
export var loading = "_oj-1";
export var noResults = "_oj-3";
export var placeholder = "_oj-2";
export var resultContent = "_oj-5";
export var resultIcon = "_oj-d";
export var resultItem = "_oj-h";
export var resultMeta = "_oj-9";
export var resultSubtitle = "_oj-7";
export var resultSuffix = "_oj-j";
export var resultTitle = "_oj-6";
export var resultsList = "_oj-4";
export var searchGroup = "_oj-e";
export var selected = "_oj-i";
export var subgroup = "_oj-c";